import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function NavDrawer() {
  const location = useLocation();
  // Map label, route, and display for each nav item
  const navItems = [
    { label: "HOME", route: "/dashboard/home" },
    // { label: "FUNDS", route: "/dashboard/funds" },
    { label: "BUDDIES", route: "/dashboard/buddies" }
  ];

  const getLinkStyle = (item) => {
    const isActive = location.pathname === item.route;
    return {
      marginBottom: item.label === "HOME" ? "28px" : "22px",
      color: isActive
        ? "#FFB300" // Highlight color
        : item.label === "HOME"
        ? "#90A4AE"
        : "#181818",
      fontWeight: isActive
        ? 900
        : item.label === "HOME"
        ? 600
        : 700,
      fontSize: item.label === "HOME" ? "1rem" : "1.08rem",
      textDecoration: isActive ? "underline" : "none",
      letterSpacing: item.label === "HOME" ? "0.15em" : "0.23em",
      transition: "color 0.2s, text-decoration 0.2s"
    };
  };

  return (
     <div style={{ flexShrink: 0, width: "120px", height: "100vh", borderRight: "1px solid #eee", background: "#fff" }}>
           

    <nav style={{
      width: "120px",
      height: "100vh",
      background: "#fff",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      borderRight: "1px solid #eee",
      paddingTop: "48px",
      letterSpacing: "0.24em",
      fontFamily: "Nunito, sans-serif"
    }}>
      {navItems.map((item) => (
        <Link
          key={item.label}
          to={item.route}
          style={getLinkStyle(item)}
        >
          {item.label}
        </Link>
      ))}
    </nav>
    </div>
  );
}
